// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';

export default class ExpandItems extends Component {
  #clickHandler: function;
  container: HTMLElement;
  #showMore: string;
  #showLess: string;
  #scroll: boolean;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp();

    this.#clickHandler = this.handleClick.bind(this);
    this.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   * Setup properties & validation
   */
  setUp(): void {
    const container: HTMLElement | null = document.querySelector('[ref="' + this.el.dataset.container + '"]');
    if (container) {
      this.container = container;
    } else {
      throw new Error('A container is required');
    }

    this.#showMore = this.el.dataset.showMore;
    this.#showLess = this.el.dataset.showLess;

    this.#scroll = this.el.dataset.scrollbar === 'true';

    if (!this.#showMore || !this.#showLess) {
      throw new Error('Translations are required');
    }
  }

  /**
   * Executes when the user clicks on the target
   */
  handleClick(): void {
    if (!this.container.classList.contains('expanded')) {
      if (this.#scroll) {
        this.container.classList.add('overflow-y-scroll');
      }
      this.container.classList.add('expanded');
      this.el.innerText = this.#showLess;
    } else {
      this.container.classList.remove('expanded');
      this.container.classList.remove('overflow-y-scroll');
      this.el.innerText = this.#showMore;
    }
  }

  /**
   * Remove all event listeners
   */
  destroy(): void {
    this.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
